(() => {
  const { openDrawer, closeDrawer } = window.ThemeUtils;
  const mobileMenu = () => document.querySelector('[data-mobile-menu]');
  const searchDrawer = () => document.querySelector('[data-search-drawer]');

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-mobile-menu-open]')) { event.preventDefault(); openDrawer(mobileMenu()); }
    if (event.target.closest('[data-mobile-menu-close]')) closeDrawer(mobileMenu());
    if (event.target.closest('[data-search-open]')) { event.preventDefault(); openDrawer(searchDrawer()); setTimeout(() => searchDrawer()?.querySelector('input[type="search"]')?.focus(), 120); }
    if (event.target.closest('[data-search-close]')) closeDrawer(searchDrawer());
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeDrawer(mobileMenu()); closeDrawer(searchDrawer());
    document.querySelectorAll('[data-nav-item].is-open').forEach((item) => item.classList.remove('is-open'));
  });

  document.querySelectorAll('[data-nav-item] > a[aria-haspopup="true"]').forEach((link) => {
    link.addEventListener('keydown', (event) => {
      if (!['Enter', ' ', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const item = link.closest('[data-nav-item]');
      item.classList.toggle('is-open');
      link.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
    });
  });
})();
